import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, TransitionGroup as _TransitionGroup, withCtx as _withCtx, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "fixed right-4 top-4 z-[80] flex w-[min(360px,calc(100vw-32px))] flex-col gap-2" }
const _hoisted_2 = { class: "text-sm font-semibold leading-5 text-slate-800" }
const _hoisted_3 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_X = _resolveComponent("X")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_TransitionGroup, { name: "toast" }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.toasts, (toast) => {
            return (_openBlock(), _createElementBlock("div", {
              key: toast.id,
              class: _normalizeClass(["flex items-start gap-3 rounded-xl border bg-white px-4 py-3 text-left shadow-2xl", $setup.toastClasses(toast.type)])
            }, [
              _createElementVNode("span", {
                class: _normalizeClass(["mt-0.5 h-2.5 w-2.5 shrink-0 rounded-full", $setup.dotClasses(toast.type)])
              }, null, 2),
              _createElementVNode("p", _hoisted_2, _toDisplayString(toast.message), 1),
              _createElementVNode("button", {
                class: "ml-auto text-slate-400 hover:text-slate-700",
                type: "button",
                "aria-label": "��ng th�ng b�o",
                onClick: ($event: any) => ($setup.removeToast(toast.id))
              }, [
                _createVNode(_component_X, {
                  size: 16,
                  "stroke-width": 2.2
                })
              ], 8, _hoisted_3)
            ], 2))
          }), 128))
        ]),
        _: 1
      })
    ])
  ]))
}